
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as tosxYezFmnWCAUunRKqlCPr84nnBy3ppwtBok8aNjJG5QgMeta } from "/app/app/pages/tos.vue?macro=true";
import { default as aboutrGPy1pFPB0rYqvDyz4_459NXlT_45DouL8moWyegH9oDWz4Meta } from "/app/app/pages/about.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_452EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__45ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as presswSPltFoWFpAQ10vV35hsOVxRsxoafbrZOSBMrEenOukMeta } from "/app/app/pages/press.vue?macro=true";
import { default as outagegH2cWHz2llYObH2sNx4nou00B_nZSl2y55h903jeu0oMeta } from "/app/app/pages/outage.vue?macro=true";
import { default as careersk1EuVkPXBMva28FSSBNatap6XCSfunEZ_VNS2TG51HgMeta } from "/app/app/pages/careers.vue?macro=true";
import { default as contact9YIjszO30YiI1EF3Yrjj3j04hZuaoJnKFtoCHkd82XkMeta } from "/app/app/pages/contact.vue?macro=true";
import { default as privacyVIQelp6ADctwcrkaUIMmUI2nV1CUDPzwpOx_DiPPWZ8Meta } from "/app/app/pages/privacy.vue?macro=true";
import { default as get_45fiberh1cZL8JsBhoHPMF2jrab7CuPWWkJE3c_45gaVeM46fUFwMeta } from "/app/app/pages/get-fiber.vue?macro=true";
import { default as indexv2yp_toDb5EUK8ku_45QAWpOo627WINk_45K3_nAWa_ufBUMeta } from "/app/app/pages/blog/index.vue?macro=true";
import { default as index7V9Hyy6rklS40bTzWRICzQEq6gfdZO2PsjxxNfnqmZQMeta } from "/app/app/pages/kiosk/index.vue?macro=true";
import { default as maintenanceB0dPhdEyV88_MoClqO_e6VO_45RgGIumEnK1cdoU0zHTYMeta } from "/app/app/pages/maintenance.vue?macro=true";
import { default as find_45addressCOhu7kGpqVwn8zU19xxwaNny_45z69T8YBmswuX_Sz37YMeta } from "/app/app/pages/find-address.vue?macro=true";
import { default as _91event_938ifwCrh6dj84jgq3grQ87H_kXXdCHrzYABjRltJuTnIMeta } from "/app/app/pages/kiosk/[event].vue?macro=true";
import { default as late_45paymentser0y8vgW3ssUoI2amRoPWbSGE1tP38S2aG2O5ecQ0KEMeta } from "/app/app/pages/late-payments.vue?macro=true";
import { default as _91article_93AtrdYgqzFGS7j7L3ybym1FECJakZtCM23HzXqgjzM8cMeta } from "/app/app/pages/blog/[article].vue?macro=true";
import { default as _91linkHash_93hTxb3br0ze6CmTmnPczicnPVSwk0p2K_qFJw2EFJt2sMeta } from "/app/app/pages/link/[linkHash].vue?macro=true";
import { default as unactivated_45userHFOVFPQ7V6d1LFWVQjRaVd3Y92r_45NqhEg0C0ikBFHWcMeta } from "/app/app/pages/unactivated-user.vue?macro=true";
import { default as business_45internet45CjUlMWdbl2zut6r2ubtCKiTiKEwO94LZfZpQ750UIMeta } from "/app/app/pages/business-internet.vue?macro=true";
import { default as already_45registeredRDNb_45JMC86TtNE0dTR2QyygI_45ipownFoDWF_CYZQIrYMeta } from "/app/app/pages/already-registered.vue?macro=true";
import { default as indexep7UqFisPgIzCR36m8BpOe7QTqSpGJmc1AvETUhkAXgMeta } from "/app/app/pages/service-areas/index.vue?macro=true";
import { default as residential_45internetJSEFyNOsXjghaHI_45bYy88AwdT4SmMET53KhiSzV7g3sMeta } from "/app/app/pages/residential-internet.vue?macro=true";
import { default as _91area_93ALl4yAwbr1Or0DXk9U06t1BmyA1m_lGo6_ntlGFEgFQMeta } from "/app/app/pages/service-areas/[area].vue?macro=true";
import { default as acceptable_45use_45policyHghGMIqfFxzTZApkRbSfOcN6RWpoLdeJahYq_459ujWN0Meta } from "/app/app/pages/acceptable-use-policy.vue?macro=true";
import { default as indexPa1q_45mO9pezpsD_456qkj0P7gM_45PkkP0CEW_45IF_459LeNhIMeta } from "/app/app/pages/forgot-password/index.vue?macro=true";
import { default as installation_45overviewd_6JYyJFd7UeLq2_45GZY0lN9J2FoT7LMb__A9EcYwN18Meta } from "/app/app/pages/installation-overview.vue?macro=true";
import { default as _91hash_93AY8LvD7igtNMIqJixUMI5OhZjIQRWpeYIEoJNYuui5YMeta } from "/app/app/pages/forgot-password/[hash].vue?macro=true";
export default [
  {
    name: "tos___en",
    path: "/tos",
    component: () => import("/app/app/pages/tos.vue")
  },
  {
    name: "tos___es",
    path: "/es/tos",
    component: () => import("/app/app/pages/tos.vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/app/app/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    component: () => import("/app/app/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__45ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__45ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "press___en",
    path: "/press",
    component: () => import("/app/app/pages/press.vue")
  },
  {
    name: "press___es",
    path: "/es/press",
    component: () => import("/app/app/pages/press.vue")
  },
  {
    name: "outage___en",
    path: "/outage",
    meta: outagegH2cWHz2llYObH2sNx4nou00B_nZSl2y55h903jeu0oMeta || {},
    component: () => import("/app/app/pages/outage.vue")
  },
  {
    name: "outage___es",
    path: "/es/outage",
    meta: outagegH2cWHz2llYObH2sNx4nou00B_nZSl2y55h903jeu0oMeta || {},
    component: () => import("/app/app/pages/outage.vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/app/app/pages/careers.vue")
  },
  {
    name: "careers___es",
    path: "/es/careers",
    component: () => import("/app/app/pages/careers.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/app/app/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/app/app/pages/contact.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/app/app/pages/privacy.vue")
  },
  {
    name: "privacy___es",
    path: "/es/privacy",
    component: () => import("/app/app/pages/privacy.vue")
  },
  {
    name: "get-fiber___en",
    path: "/get-fiber",
    component: () => import("/app/app/pages/get-fiber.vue")
  },
  {
    name: "get-fiber___es",
    path: "/es/get-fiber",
    component: () => import("/app/app/pages/get-fiber.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    component: () => import("/app/app/pages/blog/index.vue")
  },
  {
    name: "kiosk___en",
    path: "/kiosk",
    meta: index7V9Hyy6rklS40bTzWRICzQEq6gfdZO2PsjxxNfnqmZQMeta || {},
    component: () => import("/app/app/pages/kiosk/index.vue")
  },
  {
    name: "kiosk___es",
    path: "/es/kiosk",
    meta: index7V9Hyy6rklS40bTzWRICzQEq6gfdZO2PsjxxNfnqmZQMeta || {},
    component: () => import("/app/app/pages/kiosk/index.vue")
  },
  {
    name: "maintenance___en",
    path: "/maintenance",
    meta: maintenanceB0dPhdEyV88_MoClqO_e6VO_45RgGIumEnK1cdoU0zHTYMeta || {},
    component: () => import("/app/app/pages/maintenance.vue")
  },
  {
    name: "maintenance___es",
    path: "/es/maintenance",
    meta: maintenanceB0dPhdEyV88_MoClqO_e6VO_45RgGIumEnK1cdoU0zHTYMeta || {},
    component: () => import("/app/app/pages/maintenance.vue")
  },
  {
    name: "find-address___en",
    path: "/find-address",
    component: () => import("/app/app/pages/find-address.vue")
  },
  {
    name: "find-address___es",
    path: "/es/find-address",
    component: () => import("/app/app/pages/find-address.vue")
  },
  {
    name: "kiosk-event___en",
    path: "/kiosk/:event()",
    meta: _91event_938ifwCrh6dj84jgq3grQ87H_kXXdCHrzYABjRltJuTnIMeta || {},
    component: () => import("/app/app/pages/kiosk/[event].vue")
  },
  {
    name: "kiosk-event___es",
    path: "/es/kiosk/:event()",
    meta: _91event_938ifwCrh6dj84jgq3grQ87H_kXXdCHrzYABjRltJuTnIMeta || {},
    component: () => import("/app/app/pages/kiosk/[event].vue")
  },
  {
    name: "late-payments___en",
    path: "/late-payments",
    component: () => import("/app/app/pages/late-payments.vue")
  },
  {
    name: "late-payments___es",
    path: "/es/late-payments",
    component: () => import("/app/app/pages/late-payments.vue")
  },
  {
    name: "blog-article___en",
    path: "/blog/:article()",
    meta: _91article_93AtrdYgqzFGS7j7L3ybym1FECJakZtCM23HzXqgjzM8cMeta || {},
    component: () => import("/app/app/pages/blog/[article].vue")
  },
  {
    name: "blog-article___es",
    path: "/es/blog/:article()",
    meta: _91article_93AtrdYgqzFGS7j7L3ybym1FECJakZtCM23HzXqgjzM8cMeta || {},
    component: () => import("/app/app/pages/blog/[article].vue")
  },
  {
    name: "link-linkHash___en",
    path: "/link/:linkHash()",
    meta: _91linkHash_93hTxb3br0ze6CmTmnPczicnPVSwk0p2K_qFJw2EFJt2sMeta || {},
    component: () => import("/app/app/pages/link/[linkHash].vue")
  },
  {
    name: "link-linkHash___es",
    path: "/es/link/:linkHash()",
    meta: _91linkHash_93hTxb3br0ze6CmTmnPczicnPVSwk0p2K_qFJw2EFJt2sMeta || {},
    component: () => import("/app/app/pages/link/[linkHash].vue")
  },
  {
    name: "unactivated-user___en",
    path: "/unactivated-user",
    component: () => import("/app/app/pages/unactivated-user.vue")
  },
  {
    name: "unactivated-user___es",
    path: "/es/unactivated-user",
    component: () => import("/app/app/pages/unactivated-user.vue")
  },
  {
    name: "business-internet___en",
    path: "/business-internet",
    component: () => import("/app/app/pages/business-internet.vue")
  },
  {
    name: "business-internet___es",
    path: "/es/business-internet",
    component: () => import("/app/app/pages/business-internet.vue")
  },
  {
    name: "already-registered___en",
    path: "/already-registered",
    component: () => import("/app/app/pages/already-registered.vue")
  },
  {
    name: "already-registered___es",
    path: "/es/already-registered",
    component: () => import("/app/app/pages/already-registered.vue")
  },
  {
    name: "service-areas___en",
    path: "/service-areas",
    component: () => import("/app/app/pages/service-areas/index.vue")
  },
  {
    name: "service-areas___es",
    path: "/es/service-areas",
    component: () => import("/app/app/pages/service-areas/index.vue")
  },
  {
    name: "residential-internet___en",
    path: "/residential-internet",
    component: () => import("/app/app/pages/residential-internet.vue")
  },
  {
    name: "residential-internet___es",
    path: "/es/residential-internet",
    component: () => import("/app/app/pages/residential-internet.vue")
  },
  {
    name: "service-areas-area___en",
    path: "/service-areas/:area()",
    component: () => import("/app/app/pages/service-areas/[area].vue")
  },
  {
    name: "service-areas-area___es",
    path: "/es/service-areas/:area()",
    component: () => import("/app/app/pages/service-areas/[area].vue")
  },
  {
    name: "acceptable-use-policy___en",
    path: "/acceptable-use-policy",
    meta: acceptable_45use_45policyHghGMIqfFxzTZApkRbSfOcN6RWpoLdeJahYq_459ujWN0Meta || {},
    component: () => import("/app/app/pages/acceptable-use-policy.vue")
  },
  {
    name: "acceptable-use-policy___es",
    path: "/es/acceptable-use-policy",
    meta: acceptable_45use_45policyHghGMIqfFxzTZApkRbSfOcN6RWpoLdeJahYq_459ujWN0Meta || {},
    component: () => import("/app/app/pages/acceptable-use-policy.vue")
  },
  {
    name: "forgot-password___en",
    path: "/forgot-password",
    component: () => import("/app/app/pages/forgot-password/index.vue")
  },
  {
    name: "forgot-password___es",
    path: "/es/forgot-password",
    component: () => import("/app/app/pages/forgot-password/index.vue")
  },
  {
    name: "installation-overview___en",
    path: "/installation-overview",
    component: () => import("/app/app/pages/installation-overview.vue")
  },
  {
    name: "installation-overview___es",
    path: "/es/installation-overview",
    component: () => import("/app/app/pages/installation-overview.vue")
  },
  {
    name: "forgot-password-hash___en",
    path: "/forgot-password/:hash()",
    component: () => import("/app/app/pages/forgot-password/[hash].vue")
  },
  {
    name: "forgot-password-hash___es",
    path: "/es/forgot-password/:hash()",
    component: () => import("/app/app/pages/forgot-password/[hash].vue")
  }
]